import {useState} from "react";


export default function Accordion({title, blurb}) {

    const [isExpanded, setIsExpanded] = useState(false)

    return (
        <div>
            <div className="container">
                <div className="layout row layout-builder__layout">
                    <div className="col-12">
                        <div
                            className="_none block block-layout-builder block-inline-blockixm-blocks-accordion ixm-blocks--accordion my-2">
                            <div className="accordion">
                                <div
                                    className="shadow-none accordion-item border-2 rounded-0 border-gray-700">
                                    <h2 className="accordion-header">
                                        <button
                                            className={`${isExpanded ? "" : "collapsed"} bg-transparent shadow-none accordion-button text-primary fs-6 fw-bold`}
                                            onClick={() => {
                                                const opening = !isExpanded;
                                                setIsExpanded(opening);
                                                if (opening && typeof window.gtag === "function") {
                                                    window.gtag("event", "faq_open", { faq_title: title });
                                                }
                                            }}>
                                            {title}
                                        </button>
                                    </h2>
                                    <div
                                        className={`${isExpanded ? "" : "accordion-collapse collapse" }`}>
                                        <div className="accordion-body">
                                            {blurb}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}